"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatabasePropertiesFactoryObjectFromJS = exports.DatabasePropertiesFactoryFromJS = exports.DatabasePropertiesFactory = exports.DatabasePropertiesRecord = void 0;
const immutable_1 = require("immutable");
const bases_1 = require("../bases");
const IDatabaseParameter_1 = require("./IDatabaseParameter");
exports.DatabasePropertiesRecord = Object.assign(Object.assign({}, bases_1.BaseCacheableProviderRecord), { commandText: null, parameters: (0, immutable_1.List)() });
exports.DatabasePropertiesFactory = (0, immutable_1.Record)(exports.DatabasePropertiesRecord);
const DatabasePropertiesFactoryFromJS = function (data) {
    return (0, exports.DatabasePropertiesFactory)((0, exports.DatabasePropertiesFactoryObjectFromJS)(data));
};
exports.DatabasePropertiesFactoryFromJS = DatabasePropertiesFactoryFromJS;
const DatabasePropertiesFactoryObjectFromJS = function (data) {
    return Object.assign(Object.assign({}, (0, bases_1.BaseCacheableProviderFactoryObjectFromJS)(data)), { commandText: data.commandText, parameters: (0, immutable_1.List)(data.parameters ? data.parameters.map(i => (0, IDatabaseParameter_1.DatabaseParameterFactoryFromJS)(i)) : []) });
};
exports.DatabasePropertiesFactoryObjectFromJS = DatabasePropertiesFactoryObjectFromJS;
//# sourceMappingURL=IDatabaseProperties.js.map